import React from 'react'
import useDFPSlot from '@/hooks/useDFPSlot'
import styled from 'styled-components'
import RankingOtrasCarreras from '@/components/Ranking/RankingOtrasCarreras'

const Banner = styled.div`
  width: 300px;
  height: 600px;
  margin: 1rem auto;
  overflow: hidden;
  @media (orientation: portrait) {
    width: 300px;
    height: 250px;
  }
`

const Sidebar = ({
  activeRankingIndex,
  allRankings,
  ranking,
  career,
  sectionslug,
  allData,
}) => {
  const randsuffix = Math.random().toString(36).slice(2)
  const { comoseleccionan, slug } = career
  useDFPSlot({
    path: `/124506296/Especiales/Especial_RankingUniversidades_LT/${slug}_300x600`,
    sizes: [
      [300, 250],
      [300, 600],
    ],
    id: `div-gpt-ad-${slug}`,
    category: slug,
  })
  return (
    <div className="mx-auto">
      {sectionslug !== 'rankings-generales' && (
        <>{slug !== 'enfermeria' && <Banner id={`div-gpt-ad-${slug}`} />}</>
      )}
      <div className="sm:p-4 p-2">
        <RankingOtrasCarreras
          activeRankingIndex={activeRankingIndex}
          allRankings={allRankings}
          sectionslug={sectionslug}
        />
      </div>
      {sectionslug !== 'rankings-generales' && (
        <div className="sm:p-4 p-2">
          <h3 className=" leading-none font-bold py-8 ">
            ¿Cómo seleccionan las universidades?
          </h3>
          <p>{comoseleccionan}</p>
        </div>
      )}
    </div>
  )
}

export default Sidebar
